<template>
  <b-modal
    size="xl"
    no-close-on-backdrop
    hide-footer
    id="new_finance_client"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
    content-class="modern-modal"
  >
    <template #modal-header="{ close }">
      <div class="modal-header-modern">
        <h3 class="modal-title-modern">
          <i class="fas fa-user-plus mr-3"></i>
          Novo Cliente
        </h3>
        <button type="button" class="close-btn-modern" @click="close()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </template>

    <div class="modern-form-container">
      <form @submit.prevent="create">
        <!-- Navigation Tabs -->
        <div class="tabs-container">
          <nav class="modern-tabs">
            <button
              type="button"
              class="tab-button active"
              data-toggle="tab"
              data-target="#informacoes-client"
              aria-controls="informacoes-client"
            >
              <i class="fas fa-user tab-icon"></i>
              <span class="tab-text">Informações</span>
            </button>
            <button
              type="button"
              class="tab-button"
              data-toggle="tab"
              data-target="#endereco-client"
              aria-controls="endereco-client"
            >
              <i class="fas fa-map-marker-alt tab-icon"></i>
              <span class="tab-text">Endereço</span>
            </button>
            <button
              type="button"
              class="tab-button"
              data-toggle="tab"
              data-target="#informacoes-bancaria-client"
              aria-controls="informacoes-bancaria-client"
            >
              <i class="fas fa-university tab-icon"></i>
              <span class="tab-text">Dados Bancários</span>
            </button>
          </nav>
        </div>

        <!-- Tab Content -->
        <div class="tab-content-modern">
          <!-- Informações Pessoais -->
          <div class="tab-pane-modern active" id="informacoes-client">
            <div class="form-section">
              <div class="section-header">
                <h4 class="section-title">
                  <i class="fas fa-id-card mr-2"></i>
                  Dados Pessoais
                </h4>
              </div>

              <div class="form-grid">
                <WarningRequiredFields />

                <div v-if="false" class="form-group full-width">
                  <label class="form-label">Vincular Residente</label>
                  <select
                    @change="handleChangeResidentId($event.target.value)"
                    v-model="resident_id"
                    class="form-control-modern"
                  >
                    <option value="">Selecione...</option>
                    <option
                      v-for="(resident, key) in residents"
                      :value="resident.id"
                      :key="key"
                    >
                      {{ resident.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group checkbox-group">
                  <div class="custom-checkbox">
                    <input
                      class="checkbox-input"
                      type="checkbox"
                      v-model="is_foreign"
                      id="is_foreign"
                    />
                    <label class="checkbox-label" for="is_foreign">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-text">Estrangeiro</span>
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">CPF/CNPJ</label>
                  <input
                    type="text"
                    v-model="cpf_cnpj"
                    class="form-control-modern"
                    placeholder="Digite o CPF ou CNPJ"
                  />
                </div>

                <div class="form-group">
                  <LabelRequiredField label="Nome/Razão Social" />
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="name"
                    placeholder="Digite o nome completo"
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Nome Fantasia</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="fantasy_name"
                    placeholder="Digite o nome fantasia"
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Inscrição Estadual</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="ie"
                    placeholder="Digite a I.E."
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Inscrição Municipal</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="im"
                    placeholder="Digite a I.M."
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">E-mail</label>
                  <input
                    type="email"
                    class="form-control-modern"
                    v-model="email"
                    placeholder="exemplo@email.com"
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Telefone</label>
                  <BInputPhone v-model="telephone" />
                </div>
              </div>
            </div>
          </div>

          <!-- Endereço -->
          <div class="tab-pane-modern" id="endereco-client">
            <div class="form-section">
              <div class="section-header">
                <h4 class="section-title">
                  <i class="fas fa-home mr-2"></i>
                  Endereço Completo
                </h4>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">CEP</label>
                  <BInputCEP @retrieved="inputCEP" v-model="cep" />
                </div>

                <div class="form-group">
                  <label class="form-label">Endereço</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="address"
                    placeholder="Rua, avenida, etc."
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Número</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="address_number"
                    placeholder="Nº"
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Complemento</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="complement"
                    placeholder="Apto, sala, etc."
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Bairro</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="neighborhood"
                    placeholder="Nome do bairro"
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Estado</label>
                  <select v-model="uf_id" class="form-control-modern">
                    <option value="">Selecione o estado...</option>
                    <option
                      v-for="(item, key) in ufs"
                      :value="item.id"
                      :key="key"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">Cidade</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="city"
                    placeholder="Nome da cidade"
                  />
                </div>

                <div v-show="is_foreign" class="form-group">
                  <label class="form-label">País</label>
                  <select v-model="country" class="form-control-modern">
                    <option value="">Selecione o país...</option>
                    <option
                      v-for="(item, key) in countries"
                      :value="item.name"
                      :key="key"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- Informações Bancárias -->
          <div class="tab-pane-modern" id="informacoes-bancaria-client">
            <div class="form-section">
              <div class="section-header">
                <h4 class="section-title">
                  <i class="fas fa-credit-card mr-2"></i>
                  Dados Bancários
                </h4>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">Banco</label>
                  <select v-model="bank_id" class="form-control-modern">
                    <option value="">Selecione o banco...</option>
                    <option
                      v-for="(item, key) in banks"
                      :value="item.id"
                      :key="key"
                    >
                      {{ item.code ? `${item.code} - ` : "" }} {{ item.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">Agência</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="agency"
                    placeholder="Número da agência"
                  />
                </div>

                <div class="form-group">
                  <label class="form-label">Conta</label>
                  <input
                    type="text"
                    class="form-control-modern"
                    v-model="account"
                    placeholder="Número da conta"
                  />
                </div>

                <div class="form-group full-width">
                  <label class="form-label">Observações</label>
                  <ChromeSpeechToTextTextarea v-model="note" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Error Messages -->
        <ErrorsMessages :errors="errors" />

        <!-- Action Buttons -->
        <div class="actions-section">
          <v-btn
            :disabled="loading"
            @click="create"
            class="save-btn"
            :loading="loading"
          >
            <i class="fas fa-save mr-2"></i>
            {{ loading ? "Salvando..." : "Salvar Cliente" }}
          </v-btn>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import LabelRequiredField from "../../Components/LabelRequiredField";
import WarningRequiredFields from "../../Components/WarningRequiredFields";
import BInputCEP from "../../Components/BInputCEP";
import BInputPhone from "../../Components/BInputPhone";
import ChromeSpeechToTextTextarea from "../../Components/ChromeSpeechToTextTextarea";
import api from "../../../services/api";
import toast from "../../../lib/ToastNotification";
import countries from "../../../lib/countries";
import { getStatic } from "../../../lib/functions";

export default {
  name: "NewFinanceClient",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    BInputCEP,
    BInputPhone,
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
  },

  data() {
    return {
      residents: [],
      ufs: [],
      banks: [],
      countries: [],
      resident_id: "",
      cpf_cnpj: "",
      is_foreign: false,
      name: "",
      fantasy_name: "",
      ie: "",
      im: "",
      email: "",
      telephone: "",
      cep: "",
      city: "",
      country: "",
      neighborhood: "",
      complement: "",
      address: "",
      address_number: "",
      uf_id: "",
      bank_id: "",
      agency: "",
      account: "",
      note: "",
      errors: [],
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  mounted() {
    // Initialize tabs functionality
    this.initializeTabs();
  },

  methods: {
    initializeTabs() {
      const tabs = document.querySelectorAll(".tab-button");
      const panes = document.querySelectorAll(".tab-pane-modern");

      tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
          e.preventDefault();

          // Remove active class from all tabs and panes
          tabs.forEach((t) => t.classList.remove("active"));
          panes.forEach((p) => p.classList.remove("active"));

          // Add active class to clicked tab
          tab.classList.add("active");

          // Show corresponding pane
          const target = tab.getAttribute("data-target");
          const targetPane = document.querySelector(target);
          if (targetPane) {
            targetPane.classList.add("active");
          }
        });
      });
    },

    async evOnShow() {
      this.resident_id = "";
      this.cpf_cnpj = "";
      this.is_foreign = false;
      this.name = "";
      this.fantasy_name = "";
      this.ie = "";
      this.im = "";
      this.email = "";
      this.telephone = "";
      this.cep = "";
      this.city = "";
      this.country = "";
      this.neighborhood = "";
      this.complement = "";
      this.address = "";
      this.address_number = "";
      this.uf_id = "";
      this.bank_id = "";
      this.agency = "";
      this.account = "";
      this.note = "";
      this.errors = [];
    },

    async evOnShown() {
      // Reinitialize tabs when modal is shown
      this.$nextTick(() => {
        this.initializeTabs();
      });
    },

    async evOnHide() {},

    async retrieve() {
      this.countries = countries;
      await this.getResidents();

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.banks = (await getStatic("/banks", true)).banks;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/residents-actives-by-dont-linked-with-financial-client"
        );

        const { data } = response.data;
        this.residents = data;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    inputCEP(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );

      if (matched_uf) {
        this.uf_id = matched_uf.id;
      }
    },

    handleChangeResidentId(resident_id) {
      let resident = this.residents.filter(({ id }) => id == resident_id);
      if (resident.length > 0) {
        this.name = resident[0].name;
        this.cpf_cnpj = resident[0].cpf;
        this.address = resident[0].address ? resident[0].address : "";
        this.address_number = resident[0].number_address
          ? resident[0].number_address
          : "";
        this.uf_id = resident[0].uf_id ? resident[0].uf_id : "";
        this.city = resident[0].city ? resident[0].city : "";
        this.complement = resident[0].complement ? resident[0].complement : "";
      }
    },

    async create() {
      try {
        this.loading = true;

        const {
          resident_id,
          cpf_cnpj,
          is_foreign,
          name,
          fantasy_name,
          ie,
          im,
          email,
          telephone,
          cep,
          city,
          country,
          neighborhood,
          complement,
          address,
          address_number,
          uf_id,
          bank_id,
          agency,
          account,
          note,
        } = this;

        let params = {
          resident_id,
          cpf_cnpj,
          is_foreign,
          name,
          fantasy_name,
          ie,
          im,
          email,
          telephone,
          cep,
          city,
          country,
          neighborhood,
          complement,
          address,
          address_number,
          uf_id,
          bank_id,
          agency,
          account,
          note,
        };

        const response = await api.post("/rest-home/financial/client", params);

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("new_finance_client");
          this.$emit("create", { id });
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modern-modal >>> .modal-content {
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
}

.modal-header-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  padding: 24px 32px;
  border-radius: 16px 16px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
}

.modal-title-modern {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
}

.close-btn-modern {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn-modern:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

/* Form Container */
.modern-form-container {
  padding: 0;
}

/* Tabs Styling */
.tabs-container {
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.modern-tabs {
  display: flex;
  padding: 0 32px;
}

.tab-button {
  background: transparent;
  border: none;
  padding: 16px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  color: #64748b;
  font-weight: 500;
}

.tab-button:hover {
  color: #0f65b0;
  background: rgba(15, 101, 176, 0.05);
}

.tab-button.active {
  color: #0f65b0;
  border-bottom-color: #0f65b0;
  background: white;
}

.tab-icon {
  font-size: 14px;
}

.tab-text {
  font-size: 14px;
}

/* Tab Content */
.tab-content-modern {
  background: white;
}

.tab-pane-modern {
  display: none;
  padding: 32px;
}

.tab-pane-modern.active {
  display: block;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
}

.section-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  align-items: start;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group.checkbox-group {
  justify-content: center;
  align-items: flex-start;
}

/* Form Controls */
.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.form-control-modern {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;

}

.form-control-modern:focus {
  outline: none;
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.form-control-modern::placeholder {
  color: #9ca3af;
}

/* Custom Checkbox */
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.checkbox-indicator {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-radius: 4px;
  position: relative;
  transition: all 0.3s ease;
  background: white;
}

.checkbox-input:checked + .checkbox-label .checkbox-indicator {
  background: #0f65b0;
  border-color: #0f65b0;
}

.checkbox-input:checked + .checkbox-label .checkbox-indicator::after {
  content: "✓";
  position: absolute;
  color: white;
  font-size: 12px;
  font-weight: bold;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkbox-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

/* Actions */
.actions-section {
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
  text-align: right;
  border-radius: 0 0 16px 16px;
}

.save-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 180px !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.save-btn:disabled {
  opacity: 0.7 !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-header-modern {
    padding: 20px 24px;
  }

  .modal-title-modern {
    font-size: 18px;
  }

  .modern-tabs {
    padding: 0 16px;
    flex-wrap: wrap;
  }

  .tab-button {
    padding: 12px 16px;
    font-size: 13px;
  }

  .tab-pane-modern {
    padding: 24px 16px;
  }

  .section-header {
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .actions-section {
    padding: 20px 16px;
  }

  .save-btn {
    width: 100% !important;
    padding: 16px !important;
  }
}

@media (max-width: 480px) {
  .modern-tabs {
    flex-direction: column;
  }

  .tab-button {
    justify-content: center;
    border-bottom: 1px solid #e5e7eb;
    border-right: none;
  }

  .tab-button.active {
    border-bottom-color: #e5e7eb;
    border-left: 3px solid #0f65b0;
  }
}
</style>